/** Contadores mostrados como badge en subítems del menú v2. */
export interface SidebarMenuBadgeCounts {
  preRegistrations: number;
  chat: number;
  reservations: number;
  /** Reservado para integración Tickets; 0 sin ese módulo. */
  pqrs: number;
}

export const EMPTY_SIDEBAR_MENU_BADGE_COUNTS: SidebarMenuBadgeCounts = {
  preRegistrations: 0,
  chat: 0,
  reservations: 0,
  pqrs: 0,
};
